import React, { useState } from "react";
import Options from "../Compartido/options";
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import axios from 'axios';

const Content = ({ lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [nombre, setNombre] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [email, setEmail] = useState('');

    const [calle, setCalle] = useState('');
    const [numero, setNumero] = useState('');
    const [piso, setPiso] = useState('');
    const [puerta, setPuerta] = useState('');
    const [codpod, setCodPod] = useState('');
    const [ciudad, setCiudad] = useState('Barcelona');

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = "/enviadenuncia";

        let elnombre = nombre;
        let losapellidos = apellidos;
        let elmail = email;

        let lacalle = calle;
        let elnumero = numero;
        let elpiso = piso;
        let lapuerta = puerta;
        let elcodpod = codpod;
        let laciudad = ciudad;

        let elidioma = document.getElementById("idioma").value;


        let token = document.getElementById('meta_token').getAttribute('content');
        const result = axios.post(url, {
            nombre: elnombre,
            apellidos: losapellidos,
            email: elmail,
            calle: lacalle,
            numero: elnumero,
            piso: elpiso,
            puerta: lapuerta,
            codigopostal: elcodpod,
            ciudad: laciudad,
            lang: elidioma
        }, {
            headers: {
                'content-type': 'text/json',
                'X-CSRF-TOKEN': token
            }
        })
            .then((response) => {
                if (response.data.type === "error") {
                    Swal.fire({
                        title: "KO!",
                        html: `${t('Denuncia no enviada')}`,
                        timer: 1500,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                    });
                } else {
                    Swal.fire({
                        title: "OK!",
                        html: `${t('Denuncia enviada')}`,
                        timer: 1500,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                    }).then((result) => {
                        window.location.reload();
                    });
                }
            });
    };

    return (
        <div id="Content">
            <div className="clearfix content_wrapper">
                <div className="sections_group">
                    <div className="entry-content">

                        <div className="section" style={{ paddingTop: "60px" }}>
                            <div className="clearfix section_wrapper">
                                <div className="clearfix column_attr align_center">
                                    <h6 className="landing4-heading grey" style={{ paddingBottom: "3px", borderBottom: "1px solid #E87C0C", display: "inline-block", borderColor: "#E87C0C" }}>{t("Apartur DENUNCIA")}</h6>
                                    <hr className="no_line" style={{ margin: "0 auto 15px auto" }} />
                                </div>
                                <div className="column one column_blog">
                                    <div className="clearfix column_attr">
                                        <div className="mb-5 noticia-individual-descripcio-llarga">
                                            <h2>{t("AYUDANOS A LUCHAR CONTRA LA OFERTA ILEGAL EN EL SECTOR TURÍSTICO.")}</h2>
                                            <br />
                                            <h3>{t("APARTUR DENUNCIA")}</h3>
                                            <br />
                                            <p>
                                                <b>{t("¿Crees que en tu finca hay viviendas de uso turístico sin licencia?")}<br />
                                                    {t("Solo necesitamos la dirección postal del piso")}</b>
                                            </p>
                                            <br />
                                            <p>{t("APARTUR trabaja diariamente en la identificación y erradicación de la oferta ilegal de viviendas turísticas de Barcelona. Si bien esta situación actualmente está muy controlada gracias a la colaboración entre el Ayuntamiento y el sector privado, en APARTUR queremos dar un paso más y pedimos la colaboración ciudadana para erradicar la posible oferta ilegal de pisos turísticos que aún pueda existir en la ciudad.")}</p>
                                            <br />
                                            <p>{t("Nosotros nos encargamos de verificar si el piso es legal y de tramitar la denuncia en caso de que no lo sea.")}</p>
                                            <br />
                                            <p>{t("Si sospechas que un piso está actuando como piso turístico ilegal sin disponer de licencia, rellena el siguiente formulario y APARTUR verificará si el piso aparece o no en el Registro de pisos turísticos de la Generalitat de Catalunya. Si el piso no dispone de licencia, tramitaremos denuncia ante el Ayuntamiento de Barcelona.")}</p>
                                            <br />
                                            <p>
                                                {t("Todo el proceso es anónimo. Todas aquellas personas o entidades que nos faciliten información y contribuyan a la erradicación de posibles pisos ilegales permanecerán en el más absoluto anonimato ya que la denuncia la presentará APARTUR.")}<br /><br />
                                                {t("Si así lo solicitas, APARTUR te informará del resultado de las gestiones realizadas.")}
                                            </p>
                                            <br />
                                            <p><b>{t("APARTUR da la cara por ti. ¡Ayúdanos!")}</b></p>
                                            <br />

                                            <div id="contactWrapper">
                                                <form id="contactForm" onSubmit={handleSubmit}>
                                                    <input type="hidden" name="lang" id="idioma" value={lang.toString().toUpperCase()} />
                                                    <div className="column one-third">
                                                        <input placeholder={t("Nombre")} type="text" name="name" id="name" size="40" aria-required="true" aria-invalid="false" required
                                                            value={nombre} onChange={(e) => setNombre(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Apellidos")} type="text" name="apellidos" id="apellidos" size="40" aria-required="true" aria-invalid="false" required
                                                            value={apellidos} onChange={(e) => setApellidos(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="column one-third">
                                                        <input placeholder={t("Email")} type="email" name="email" id="email" size="100" aria-required="true" aria-invalid="false" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                                    </div>
                                                    <div className="column one">
                                                        {t("Indica los datos del piso que crees que está actuando como piso turístico ilegal sin disponer de licencia")
                                                        }
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Calle")} type="text" name="calle" id="calle" size="100" aria-invalid="false" value={calle} onChange={(e) => setCalle(e.target.value)} required />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Número")} type="text" name="numero" id="numero" size="4" aria-invalid="false" value={numero} onChange={(e) => setNumero(e.target.value)} required />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Piso")} type="text" name="piso" id="piso" size="2" aria-invalid="false" value={piso} onChange={(e) => setPiso(e.target.value)} required />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Puerta")} type="text" name="puerta" id="puerta" size="3" aria-invalid="false" value={puerta} onChange={(e) => setPuerta(e.target.value)} required />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Código Postal")} type="text" name="codpod" id="codpod" size="5" aria-invalid="false" value={codpod} onChange={(e) => setCodPod(e.target.value)} required />
                                                    </div>
                                                    <div className="column one-third">
                                                        <input placeholder={t("Ciudad")} type="text" name="ciudad" id="ciudad" size="5" aria-invalid="false" value={ciudad} onChange={(e) => setCiudad(e.target.value)} required />
                                                    </div>
                                                    <div className="column one">
                                                        <input type="submit" value={t("Enviar")} id="submit" />
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Content;
